import "./WebinarCompleted.css";

function WebinarCompleted() {
  return (
    <main className="webinar-completed">
      <section className="webinar-completed-content" aria-live="polite">
        <div className="webinar-completed-badge" aria-hidden="true">
          ✓
        </div>
        <h1 className="webinar-completed-title">انتهى هذا اللقاء</h1>
        <p className="webinar-completed-message">
          شكرا لاهتمامك، لكن موعد هذا الويبينار قد انتهى بالفعل.
        </p>
        <p className="webinar-completed-note">
          تابع صفحاتنا أو عد لاحقا لمعرفة المواعيد واللقاءات القادمة.
        </p>
      </section>
    </main>
  );
}

export default WebinarCompleted;
